import { IconFont } from '@byecode/ui'
import { DESIGN_THEME, EaseEnum, PresetEnum, TransitionTypeEnum } from '@lighthouse/core'

export const THEME_OPTIONS = [
    {
        label: '主题/浅色',
        value: DESIGN_THEME.LIGHT
    },
    {
        label: '主题/深色',
        value: DESIGN_THEME.DARK
    },
    {
        label: '自定义',
        value: DESIGN_THEME.CUSTOM
    }
]

export const OVERFLOW_OPTIONS = [
    {
        label: '隐藏',
        value: 'hidden'
    },
    {
        label: '显示',
        value: 'visible'
    },
    {
        label: '滚动',
        value: 'auto'
    }
]

export const ANIMATION_POSITION_OPTIONS = [
    {
        label: <IconFont type="StartTop" size={16} />,
        value: 'top'
    },
    {
        label: <IconFont type="StartMiddle" size={16} />,
        value: 'center'
    },
    {
        label: <IconFont type="StartBottom" size={16} />,
        value: 'bottom'
    }
]

export const ANIMATION_PRESETS_OPTIONS: { label: string; value: PresetEnum; disable?: boolean }[] = [
    {
        label: '渐显',
        value: PresetEnum.fadeIn
    },
    {
        label: '缩放',
        value: PresetEnum.scaleIn
    },

    {
        label: '底部缩放',
        value: PresetEnum.scaleInBottom
    },
    {
        label: '水平翻转',
        value: PresetEnum.flipHorizontal
    },
    {
        label: '垂直翻转',
        value: PresetEnum.flipVertical
    },
    {
        label: '顶部滑入',
        value: PresetEnum.slideInTop
    },
    {
        label: '底部滑入',
        value: PresetEnum.slideInBottom
    },
    {
        label: '左侧滑入',
        value: PresetEnum.slideInLeft
    },
    {
        label: '右侧滑入',
        value: PresetEnum.slideInRight
    },
    {
        label: '自定义',
        value: PresetEnum.custom,
        disable: true
    }
]

export const TRANSITION_OPTIONS = [
    {
        label: '缓动',
        value: TransitionTypeEnum.ease
    },
    {
        label: '弹性',
        value: TransitionTypeEnum.spring
    }
]

export const ANIMATE_OPTIONS = [
    {
        label: '循环',
        value: 'loop'
    },
    {
        label: '镜像',
        value: 'mirror'
    }
]

export const BASE_ON_OPTIONS = [
    {
        label: '时间',
        value: 'time'
    },
    {
        label: '物理现象',
        value: 'physics'
    }
]

export const EASE_OPTIONS = [
    {
        label: '线性',
        value: EaseEnum.linear
    },
    {
        label: '渐入',
        value: EaseEnum.easeIn
    },
    {
        label: '渐出',
        value: EaseEnum.easeOut
    },
    {
        label: '渐入渐出',
        value: EaseEnum.easeInOut
    },
    {
        label: '退入',
        value: EaseEnum.backIn
    },
    {
        label: '退出',
        value: EaseEnum.backOut
    },
    {
        label: '退入退出',
        value: EaseEnum.backInOut
    }
    // {
    //     label: '自定义',
    //     value: EaseEnum.custom,
    //     disable: true
    // }
]

export const ROTATE_OPTIONS = [
    {
        label: '2D旋转',
        value: '2d'
    },
    {
        label: '3D旋转',
        value: '3d'
    }
]
